
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
components: {
XHeader,
XInput,
Group,
},
name: 'orderDetail',
data () {
return {
orderDetail:{},
address:''
}
},
beforeRouteEnter (to, from, next) {
if(from.name == 'rapidrepairslist'){
next(vm => {
vm.orderDetail =vm.$route.params.order
vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district
if(vm.orderDetail.isviwo){
vm.orderDetail.isviwo = '是'
}
else {
vm.orderDetail.isviwo = '否'
}
var order = JSON.stringify(vm.orderDetail)
localStorage.setItem('order',order)
console.log( vm.orderDetail)
})
}
else {
next(vm => {
var order = localStorage.getItem('order')
vm.orderDetail = JSON.parse(order)
vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district
if(vm.orderDetail.isviwo){
vm.orderDetail.isviwo = '是'
}
else {
vm.orderDetail.isviwo = '否'
}
})
}


}
}



// WEBPACK FOOTER //
// ./src/components/quicksetup.vue